module.exports = __webpack_public_path__ + "assets/ziyuan_15.bcf272a0.svg";